<template>
    <rkm-data-table
        :fields="fields.datatables.procedimento"
        :repository="repositories.procedimento"
        :request-params="getRequestParams()"
        ref="DataTable"
    >
        <template v-slot:cell(codigo)='{ value }'>
            {{ value | formatProcedimento }}
        </template>

        <template v-slot:cell(actions)='{ item }'>
            <rkm-button
                color="primary"
                title="Selecionar procedimento."
                small
                @click.stop="$emit('select', item)"
            >
                <rkm-icon icon="check" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

// Filters.
import formatsFilters from '@/filters/formats'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    procedimento: [
                        {
                            name: 'codigo',
                            key: 'codigo',
                            label: 'Código',
                            searchable: true,
                            sortable: true,
                            class: 'col-min'
                        },
                        {
                            name: 'nome',
                            key: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min text-center'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento')
        }
    },
    filters: {
        ...formatsFilters
    },
    methods: {
        getRequestParams() {

            const params = {
                only_with_cid: this.onlyWithCid
            }

            if (this.cidId) {

                params.cid_id = this.cidId
            }

            if (this.registro) {

                params.registro = this.registro
            }

            return params
        }
    },
    mixins: [repository],
    props: {
        cidId: { type: Number },
        registro: { type: String },
        onlyWithCid: { type: Boolean, default: false }
    }
}
</script>